module.exports = __webpack_public_path__ + "img/hieda no akyuu_lw.7ee64804.png";